export enum ScrollPadding {
    ScrollPadding1 = '-sh-scroll-padding-1',
    ScrollPadding2 = '-sh-scroll-padding-2',
    ScrollPadding4 = '-sh-scroll-padding-4',
    ScrollPadding5 = '-sh-scroll-padding-5'
}
